import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';

import styles from './styles/ServiceLogo.module.css';

const AgentLogo = ({ logo, name, size = 'medium', className = '' }) => {
    const logoClassName = useMemo(() => {
        return `${styles.logo} ${styles[size]} ${className}`;
    }, [size, className]);

    const displayLetter = useMemo(() => {
        const trimmedName = name?.trim();
        return trimmedName ? trimmedName.charAt(0).toUpperCase() : '?';
    }, [name]);

    return logo ? (
        <img
            src={logo}
            alt={name || 'Agent logo'}
            className={logoClassName}
            loading="lazy"
        />
    ) : (
        <div className={`${styles.emptyLogo} ${logoClassName}`}>
            <span className={styles.letter}>{displayLetter}</span>
        </div>
    );
};

AgentLogo.propTypes = {
    logo: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.oneOfType([
        PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'xlarge']),
        PropTypes.number,
    ]),
    className: PropTypes.string,
};

export default memo(AgentLogo);
